import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  setTemporaryNotifications,
  deleteTemporaryNotification,
} from 'redux/notifications/actions';
import { sendFormDataHandler } from 'redux/forms/actions';

import AlertModalContainer from './AlertModalContainer/AlertModalContainer';
import { isFormDataInLocalStorage } from 'utils/LocalStorageHelper';
import { Alert, AlertAction } from './index';
import { ModalBlank } from 'components/commons/Modals';

function AlertContainer() {
  const [dataToShow, setDataToShow] = React.useState({});
  const [modalOpen, setModalOpen] = React.useState(false);

  const dispatch = useDispatch();

  const { temporaryNotifications } = useSelector(({ notifications }) => ({
    temporaryNotifications: notifications.temporaryNotifications.notifications,
  }));

  React.useEffect(() => {
    if (isFormDataInLocalStorage()) {
      const keysOfData = Object.keys(localStorage).filter((key) => key.startsWith('setFormEvent'));
      keysOfData.forEach((key) => {
        dispatch(setTemporaryNotifications(JSON.parse(localStorage.getItem(key))));
      });
    }
  }, []);

  React.useEffect(() => {
    if (temporaryNotifications && temporaryNotifications.length > 0) {
      const interval = setInterval(() => {
        if (!modalOpen) {
          dispatch(deleteTemporaryNotification(temporaryNotifications[0]));
        }
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [temporaryNotifications, modalOpen]);

  const openModalHandler = (e, data) => {
    e.stopPropagation();
    setDataToShow(data);
    setModalOpen(true);
  };

  const deleteDataHandler = (data) => {
    setModalOpen(false);
    if (data.extraData.localStorageName) {
      localStorage.removeItem(data.extraData.localStorageName);
      dispatch(deleteTemporaryNotification(data));
    }
  };

  const sendDataHandler = (data, dataToRemove) => {
    dispatch(sendFormDataHandler(data));
    dispatch(deleteTemporaryNotification(dataToRemove));
  };

  return (
    <>
      {temporaryNotifications && temporaryNotifications.length > 0 && (
        <div className="fixed z-[100] top-8 right-[50%] translate-x-2/4 md:translate-x-0 md:right-12 flex flex-col transition">
          {temporaryNotifications &&
            temporaryNotifications.map((item) => {
              switch (item.type) {
                case 'action':
                  return (
                    <AlertAction
                      key={item.id}
                      notification={item}
                      sendDataHandler={sendDataHandler}
                      openModalHandler={openModalHandler}
                    />
                  );

                default:
                  return <Alert key={item.id} notification={item} />;
              }
            })}
        </div>
      )}
      <ModalBlank id="alert-container-modal" modalOpen={modalOpen} setModalOpen={setModalOpen}>
        <AlertModalContainer
          dataToShow={dataToShow}
          deleteDataHandler={deleteDataHandler}
          setModalOpen={setModalOpen}
          sendDataHandler={sendDataHandler}
        />
      </ModalBlank>
    </>
  );
}

export default AlertContainer;
